import { useEffect, useState, useRef } from "react";
import useAxios from "../../hooks/useAxios";
import { useAuth } from "../../contexts/AuthContext";
import { Card } from "primereact/card";
import { Message } from "primereact/message";
import { Toast } from "primereact/toast";
import { ProgressBar } from "primereact/progressbar";
import MsisdnSearch from '../../components/MsisdnSearch';

function SubInfo() {
  const [responseData, setResponseData] = useState(null);

  const { user } = useAuth();
  const { response, error, setError, loading, fetchData } = useAxios();
  const toast = useRef(null);

  useEffect(() => {
    if (!response) return;

    // Show toast for messages
    if (response.message) {
      const severity = response.status === "error" ? "error" : response.status;
      toast.current.show({ severity, detail: response.message, life: 3000 });
    }

    setResponseData(response);
  }, [response]);

  const handleSearch = (msisdn) => {
    setResponseData(null);
    fetchData({
      method: "get",
      url: "/api/summa-sub-info",
      params: { msisdn: msisdn },
    });
  };

  if (!user) return null;

  //{response?.status === 401 || response?.status === 403  && <Message severity="error" text={response.message} className="w-full mt-6" />}
  return (
    <>
      <Toast ref={toast} position="top-right" />
      <MsisdnSearch onSubmit={handleSearch} loading={loading} title="Регистрация абонента" description="Просмотр информации о регистрации абонента по номеру MSISDN" />

      {responseData?.status === "error" && (
        <div className="p-fluid mt-4">
          <Message severity="error" text={responseData.message || "An error occurred"} className="px-3"></Message>
        </div>
      )}
      {loading && (
        <div className="mt-6">
          <ProgressBar
            mode="indeterminate"
            style={{ height: "6px" }}
          ></ProgressBar>
        </div>
      )}

      {responseData?.status === "success" && responseData?.data && (
        <div className="px-3 mt-5">
          <Card title="Регистрации в сетях" className="mt-5">
            <h4>2G/3G: {responseData.data.currentVlr ? "✅" : "❌"}</h4>
            <h4>VoLTE: {responseData.data.name ? "✅" : "❌"}</h4>
          </Card>
        </div>
      )}
    </>
  );
}

export default SubInfo;
